<template>
  <v-app class="disable-favorites">
    <v-container>
      <p>СПО мониторинг за предыдущий календарный год</p>
      <v-row align="center">
        <v-col sm="2" xl="1">
          <v-select variant="underlined" :class="selectedYear ? 'selected' : ''" v-model="selectedYear" label="Год"
            :items="$model.modules.omelchenko.model.years"></v-select>
        </v-col>
        <v-col>
          <log target="report_minobr\omelchenko" class="inline pointer">
            <template #activator="{ props }">
              <v-icon color="primary" v-bind="props">
                mdi-file-document
              </v-icon>
            </template>

            <template #data="{ log }">
              <v-card>
                <v-card-text>
                  <div v-for="(task, index) in log" :key="index">
                    <div>
                      <div class="time">{{ task[0].timecreated }}</div>
                      <div v-for="(logRecord, index0) in task" :key="index0" class="message">
                        {{ logRecord.other.message }}
                      </div>
                    </div>
                    <v-divider v-if="index != log.length - 1" />
                  </div>
                </v-card-text>
              </v-card>
            </template>
          </log>



          <v-icon color="success" class="pointer" @click="printExcel()" v-if="selectedYear && tableData">
              mdi-microsoft-excel
          </v-icon>

          <v-tooltip location="top" text="Полноэкранный режим">
            <template v-slot:activator="{ props }">
              <v-icon v-bind="props" class="pointer" @click="selectedYear ? openFullscreen() : false">
                mdi-fullscreen
              </v-icon>
            </template>
          </v-tooltip>
          <v-tooltip location="top" text="Пересчитать" v-if="!disableRecalc && selectedYear && false">
            <template v-slot:activator="{ props }">
              <v-icon v-bind="props" class="pointer" @click="selectedYear ? recalculate() : false">
                mdi-calculator
              </v-icon>
            </template>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-row v-for="(progressKey, index) in progressKeys" :key="index">
        <v-col>
          <progress-helper :progressKey="progressKey" @finish="progressFinished" />
        </v-col>
      </v-row>
      <progress-helper v-if="customProgressMessage" :message="customProgressMessage" />
    </v-container>

    <v-data-table id="reportDataTable" v-if="tableHeaders" :headers="tableHeaders" :items="tableData"
      class="elevation-1 nowrap" items-per-page="-1" fixed-header>
      <template v-slot:headers="{ columns, isSorted, getSortIcon, toggleSort }">
        <tr>
          <template v-for="head in columns" :key="head.key">
            <th>
              <v-tooltip location="top" :text="head.title" max-width="800">
                <template v-slot:activator="{ props }">
                  <div v-bind="props" style="position: relative; cursor: pointer" class="hide-long-text"
                    @click="() => toggleSort(head)">
                    {{ head.title }}
                    <template v-if="isSorted(head)">
                      <v-icon style="position: absolute; top: 0; right: 0" :icon="getSortIcon(head)"></v-icon>
                    </template>
                  </div>
                </template>
              </v-tooltip>
            </th>
          </template>
        </tr>
      </template>

      <template v-slot:item.name="{ item }">
        <v-icon class="download" color="blue darken-2"
          @click="downloadRawReport(item.ogrn)">mdi-microsoft-word</v-icon>&nbsp;{{ item.name }}&nbsp;
          
      </template>
      <template v-slot:bottom> </template>
    </v-data-table>

    <v-overlay v-model="overlay"></v-overlay>
  </v-app>
</template>

<script>
import progressHelper from "moodleDir/procollege/lib/vue/ProgressHelper.vue";
import log from "moodleDir/procollege/lib/vue/log.vue";
export default {
  components: {
    progressHelper,
    log,
  },
  data() {
    return {
      excelFields: {},
      excelData: [],

      selectedYear: null,
      overlay: false,
      progressKeys: [],
      customProgressMessage: null,
      tableHeaders: [],
      tableData: [],
      disableRecalc: false,
    };
  },
  created() {
    this.axios
      .post(
        this.$model.wwwroot +
        "/procollege/core_procollege/helpers/ProgressHelper/clearNotTask",
        new URLSearchParams({
          template: document.location.pathname + document.location.hash,
        })
      )
      .then((response) => {
        this.axios
          .post(
            this.$model.wwwroot +
            "/procollege/core_procollege/helpers/ProgressHelper/getAllTask",
            new URLSearchParams({
              page: document.location.pathname + document.location.hash,
            })
          )
          .then((response) => {
            this.progressKeys = response.data;
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        console.log(error);
      });
  },
  watch: {
    selectedYear: function (val) {
      if (val) {
        this.getReport();
      }
    },
  },
  methods: {
    upload(files,ogrn) {
      if (files.length == 0) {
        return;
      }
      this.customProgressMessage = "Загрузка файлов";
      let formData = new FormData();

      for (let file of files) {
        formData.append("files[]", file, file.name);
      }
      formData.append("year", this.selectedYear);

      if(ogrn != undefined){
        formData.append("ogrn", ogrn);
      }
      formData.append(
        "page",
        document.location.pathname + document.location.hash
      );

      this.axios
        .post(
          this.$model.wwwroot +
          "/procollege/report/minobr/omelchenko/saveReport",
          formData
        )
        .then((response) => {
          this.customProgressMessage = null;
          this.progressKeys.push(response.data);
        })
        .catch((error) => {
          this.customProgressMessage = null;
          console.log(error);
        });
    },
    recalculate() {
      let formData = new FormData();
      this.disableRecalc = true;
      formData.append("year", this.selectedYear);
      formData.append(
        "page",
        document.location.pathname + document.location.hash
      );

      this.axios
        .post(
          this.$model.wwwroot +
          "/procollege/report/minobr/omelchenko/recalculate",
          formData
        )
        .then((response) => {
          this.disableRecalc = response.data;
          this.customProgressMessage = null;
          this.progressKeys.push(response.data);
        })
        .catch((error) => {
          this.disableRecalc = false;
          this.customProgressMessage = null;
          console.log(error);
        });
    },
    downloadRawReport(ogrn) {
      this.axios
        .post(
          this.$model.wwwroot +
          "/procollege/report/minobr/omelchenko/downloadRawReport?ogrn=" +
          ogrn +
          "&year=" +
          this.selectedYear,
          null,
          {
            responseType: "blob",
            headers: {
              "Content-Type": "application/octet-stream",
            },
          }
        )
        .then((response) => {
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: "application/zip" })
          );
          const link = document.createElement("a");
          link.href = url;
          link.target = "_blank";
          link.setAttribute(
            "download",
            ogrn + "-" + this.selectedYear + ".zip"
          );
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch(() => console.log("error occured"));
    },
    getReport() {
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/report/minobr/omelchenko/getReport",
          new URLSearchParams({
            year: this.selectedYear,
          })
        )
        .then((response) => {
          this.tableHeaders = response.data.headers;
          this.tableData = response.data.data;
          this.excelData = response.data.data;

          this.excelFields = {};
          this.tableHeaders.forEach((header) => {
            this.excelFields[header.title] = header.key;
          });

          this.excelData.forEach((element) => {
            for (let prop in element) {
              element[prop] += "";
              element[prop] = element[prop].replace(".", ",");
            }
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    printExcel() {
      this.axios
        .post(
          this.$model.wwwroot +
          "/procollege/report/minobr/omelchenko/printExcel",
          new URLSearchParams({
            reportType: this.reportType,
            year: this.selectedYear
          }),
          {
            responseType: 'blob'
          }
        )
        .then((response) => {
          let link = document.createElement("a");
          link.href = URL.createObjectURL(response.data);

          let filename = "report.xlsx"
          if (typeof response.headers["content-disposition"] != "undefined") {
            let t = response.headers["content-disposition"].match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
            if (t && t[1] && t[1] != "undefined") {
              filename = decodeURIComponent(t[1]);
              filename = filename.replace(/[\"\'\\]/g, '')
            }
          }

          link.download = filename;
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href)
          document.body.removeChild(link);
        })
        .catch((error) => {
          this.$eventBus.$emit("show-dialog", {
            title: "Ошибка",
            content: error.response.data,
          });
          console.log(error);
          console.log(error);
        }).finally(() => {
        });
    },
    openFullscreen() {
      var elem = document.getElementById("reportDataTable");

      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Safari */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE11 */
        elem.msRequestFullscreen();
      }
    },
    progressFinished(key) {
      this.getReport();
      if (this.disableRecalc == key) {
        this.disableRecalc = false;
      }
      var index = this.progressKeys.indexOf(key);
      if (index !== -1) {
        this.progressKeys.splice(index, 1);
      }
    },
  },
};
</script>
<style>
#reportDataTable tbody>tr>td:first-child,
#reportDataTable thead>tr>th:first-child {
  position: sticky !important;
  left: 0;
  z-index: 1;
  background-color: white;
}
</style>
<style scoped>
.download {
  cursor: pointer;
}

.selected:v-deep div.v-select__slot {
  height: 40px;
}

.time {
  font-size: 10pt;
  color: #000;
  opacity: 0.5;
}

.message {
  font-size: 12pt;
  color: darkslateblue;
  border: none;
}

.inline {
  display: inline;
}

.pointer {
  cursor: pointer;
}

#reportDataTable {
  overflow-y: scroll;
}

.hide-long-text {
  max-height: 150px;
  overflow: hidden;
}
.hide-input :deep(.v-input__control){
  display: none;
}
</style>
